
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IApiPagingParams, IApiPage } from '../paging/paging-service.types';
import { IApiDocument, IApiGetDocumentListParams } from './document-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getDocumentList = (params: IApiPagingParams<IApiGetDocumentListParams>) => {
    return axios.get<IApiPage<IApiDocument>>(`${DocApiBaseUrl}/document`, { params: params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const getDocumentByKey = (documentKey: string) => {
    return axios.get<IApiDocument>(`${DocApiBaseUrl}/document/${documentKey}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}